import React from 'react';
import { Typography, Container, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function Dashboard() {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('jwtToken'); // Remove the JWT token
        navigate('/'); // Redirect to the sign-in page
    };

    return (
        <Container component="main" maxWidth="md">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography component="h1" variant="h4">
                    Welcome to your Dashboard!
                </Typography>
                <Typography variant="body1" sx={{ mt: 2 }}>
                    You have successfully logged in. This is your personalized dashboard.
                </Typography>
                <Button
                    id="dashboard-logout-button"
                    variant="contained"
                    color="primary"
                    onClick={handleLogout}
                    sx={{ mt: 3 }}
                >
                    Logout
                </Button>
            </Box>
        </Container>
    );
}

export default Dashboard;